import { useQuery } from '@tanstack/react-query';
import { normalize } from 'normalizr';

import {
  Quiz,
  QuizAnswer,
  QuizQuestion,
  QuizSchema,
} from '~teacher/models/quizzes';

import { getQuizById } from '../../api/quizApi';

export type QuizResponse = {
  quiz: Quiz;
  quizQuestion: Record<string, QuizQuestion>;
  quizAnswer: Record<string, QuizAnswer>;
};

interface GetQuizParams {
  quizId: number;
  quizUrl: ({ quizId }?: { quizId?: number }) => string;
}

export async function getQuiz({
  quizId,
  quizUrl,
}: GetQuizParams): Promise<QuizResponse> {
  const data = await getQuizById({ quizId: quizId, quizUrl: quizUrl });
  const result = normalize<
    any,
    {
      quiz: Record<string, Quiz>;
      quizQuestion: Record<string, QuizQuestion>;
      quizAnswer: Record<string, QuizAnswer>;
    },
    any
  >(data, QuizSchema);
  const {
    entities: { quiz, quizQuestion = {}, quizAnswer = {} },
  } = result;

  return {
    quiz: Object.values<Quiz>(quiz)[0],
    quizQuestion,
    quizAnswer,
  };
}

export function useQuiz(
  quizId: number,
  quizUrl: ({ quizId }?: { quizId?: number }) => string
) {
  return useQuery({
    queryKey: ['quiz', quizId],
    queryFn: () => getQuiz({ quizId: quizId, quizUrl: quizUrl }),
    enabled: !!quizId,
  });
}
